// extracted by mini-css-extract-plugin
export default {"correctPrice":"manualCreditNoteForm_correctPrice__RIHMN","modeHint":"manualCreditNoteForm_modeHint__m7MTD"};